import React from "react";
import { useBreadcrumb } from "gatsby-plugin-breadcrumb";
import { MDXProvider } from "@mdx-js/react";
import { MDXRenderer } from "gatsby-plugin-mdx";
import Breadcrumbs from "../components/Navigation/breadcrumbs";
import CarerrBox from "../components/Career/carerrBox";
import JobOffers from "../components/Career/jobOffers";
import ContactDetails from "../components/Contact/contactDetails";

const Page = ({ location, mdx, allMdx }) => {
  const { crumbs } = useBreadcrumb({
    location,
    crumbLabel: mdx?.frontmatter?.title,
  });
  return (
    <>
      <Breadcrumbs crumbs={crumbs} />
      <div className="container">
        <h1 className="page-title">{mdx?.frontmatter?.title}</h1>
      </div>
      <div className="container container__page">
        <MDXProvider
          components={{
            CarerrBox,
            ContactDetails,
            JobOffers: (props) => (
              <JobOffers {...props} allMdx={allMdx ? allMdx : null} />
            ),
            span: (props) => <span {...props} style={{ color: "#ffcb00" }} />,
          }}
        >
          <MDXRenderer frontmatter={mdx.frontmatter}>{mdx.body}</MDXRenderer>
        </MDXProvider>
      </div>
    </>
  );
};
export default Page;
